import { useEffect } from "react";
import SecureStorage from "react-secure-storage";

const BeforeUnloadWarning = () => {
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      const createdPatientCode = SecureStorage.getItem("createdPatientCode");

      if (createdPatientCode) {
        // 표준 방법
        e.preventDefault();
        // Chrome에서는 returnValue를 설정해야 함
        e.returnValue = "";

        // 커스텀 메시지 (대부분의 브라우저에서는 표시되지 않지만 설정)
        return "";
      }
    };

    // beforeunload 이벤트 리스너 등록
    window.addEventListener("beforeunload", handleBeforeUnload);

    // cleanup: 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return null;
};

export default BeforeUnloadWarning;
